const locale = {
  PAGE_TITLE: 'Announcements',
  PAGE_SUBTITLE: 'Manage announcements displayed on the Dashboard for all users.',
  HEADER_SEARCH_PLACEHOLDER: 'Search announcements...',
  HEADER_NEW_BUTTON: '+ New Announcement',
  HEADER_STATUS_FILTER: 'Status',
  HEADER_STATUS_FILTER_PLACEHOLDER: 'Status: All',
  TAB_ALL: 'All',
  TAB_ACTIVE: 'Active',
  TAB_SCHEDULED: 'Scheduled',
  TAB_EXPIRED: 'Expired',
  TABLE_TITLE: 'Title',
  TABLE_START_DATE: 'Start Date',
  TABLE_END_DATE: 'End Date',
  TABLE_STATUS: 'Status',
  TABLE_CREATED_BY: 'Created By',
  TABLE_CREATED_ON: 'Created On',
  TABLE_ACTIONS: 'Actions',
  BUTTON_EDIT: 'Edit',
  BUTTON_DELETE: 'Delete',
  FIELD_TITLE: 'Title',
  FIELD_CONTENT: 'Announcement Content',
  FIELD_CONTENT_COUNTER: '{{count}}/{{max}} characters',
  FIELD_START_DATE: 'Start Date',
  FIELD_END_DATE: 'End Date',
  FIELD_TIME: 'Time',
  FIELD_STATUS: 'Status',
  DETAILS_SECTION: 'Announcement Details',
  FORM_TITLE_NEW: 'New Announcement',
  FORM_TITLE_EDIT: 'Edit Announcement',
  STATUS_INACTIVE: 'Inactive',
  STATUS_ACTIVE: 'Active',
  CREATE_SUCCESS: 'Announcement created successfully.',
  UPDATE_SUCCESS: 'Announcement updated successfully.',
  DELETE_SUCCESS: 'Announcement deleted successfully.',
  DELETE_CONFIRM_TITLE: 'Delete Announcement',
  DELETE_CONFIRM_CONTENT: 'Are you sure you want to delete this announcement?',
  VALIDATION_END_DATE: 'End date must be on or after start date.',
  VALIDATION_EXPIRED_DATES: 'Start date and end date cannot both be before today.',
  VALIDATION_CONTENT_MAX: 'Content must not exceed {{max}} characters (plain text).',
  PAGINATION_SHOWING: 'Showing {{from}} to {{to}} of {{total}} announcements',
  RULES_TITLE: 'Announcement Rules',
  RULES_ACTIVE: 'Active announcements are visible on the Dashboard for all users.',
  RULES_SCHEDULED: 'Scheduled announcements will become active automatically on the start date.',
  RULES_EXPIRED: 'Expired announcements are hidden from the Dashboard.',
};

export default locale;
